import React from 'react';
import { Search, ShoppingCart, TreePine, LineChart } from 'lucide-react';
import HoverText from './HoverText';

const HowItWorks = () => {
  const steps = [
    {
      icon: Search,
      number: "01",
      title: "Identifizieren",
      description: "Wir identifizieren bedrohte Waldgebiete weltweit, die dringend Schutz benötigen."
    },
    {
      icon: ShoppingCart,
      number: "02",
      title: "Erwerben",
      description: "Mit Ihrer Spende kaufen wir das Waldgebiet und sichern die Eigentumsrechte."
    },
    {
      icon: TreePine,
      number: "03",
      title: "Schützen",
      description: "Der Wald wird dauerhaft geschützt und gepflegt – und schenkt Tieren wieder ein Zuhause."
    },
    {
      icon: LineChart,
      number: "04",
      title: "Dokumentieren",
      description: "Sie erhalten regelmässige Updates über den Zustand und die Entwicklung des Waldes."
    }
  ];

  return (
    <section id="how-it-works" className="py-16 md:py-24 lg:py-32 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-left md:text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <HoverText 
            className="text-gray-900" 
            style={{ 
              fontFamily: "'Playfair Display', serif", 
              fontSize: 'clamp(28px, 5vw, 42px)', 
              fontWeight: 700,
              lineHeight: 1.2,
              textAlign: 'left',
              marginBottom: '16px'
            }}
          >
            So funktioniert's
          </HoverText>
          <HoverText 
            className="text-gray-600" 
            style={{ 
              fontSize: 'clamp(16px, 3vw, 18px)', 
              fontWeight: 400, 
              color: '#666', 
              lineHeight: 1.6,
              textAlign: 'left',
              marginBottom: '16px'
            }}
          >
            Unser transparenter Prozess garantiert, dass 100 % Ihrer Spende direkt in den Schutz bedrohter Wälder fliessen. Sämtliche Einnahmen werden vollständig und nachweisbar in unsere Projekte investiert.
          </HoverText>
          <HoverText 
            className="text-gray-600" 
            style={{ 
              fontSize: 'clamp(14px, 2.5vw, 16px)', 
              fontWeight: 400, 
              color: '#666', 
              lineHeight: 1.6,
              textAlign: 'left',
              marginBottom: '16px'
            }}
          >
            Wir gehören zu den wenigen Non-Profit-Organisationen, die keine Lohn-, Administrations- oder Marketingkosten über Spenden finanzieren. Diese Aufwendungen werden von grosszügigen Partnern im Hintergrund getragen. Dadurch ist sichergestellt, dass jeder gespendete Franken zu 100 % im Projekt ankommt.
          </HoverText>
          <HoverText 
            className="text-gray-600" 
            style={{ 
              fontSize: 'clamp(14px, 2.5vw, 16px)', 
              fontWeight: 400, 
              color: '#666', 
              lineHeight: 1.6,
              textAlign: 'left',
              marginBottom: '16px'
            }}
          >
            Diese konsequente und belegbare Herangehensweise schafft maximale Transparenz und Vertrauen – und setzt einen Standard, den nur wenige Organisationen in dieser Form umsetzen.
          </HoverText>
        </div>

        {/* Steps - MOBILE FIRST: flex-col auf Mobile, Grid ab md */}
        <div className="flex flex-col md:grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative group w-full">
                {/* Connecting Line (hidden on last item and mobile) */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-16 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-[#FF1B8D] to-[#FF9B8C] opacity-30"></div>
                )}

                {/* Card - Volle Breite auf Mobile */}
                <div className="relative bg-white rounded-2xl p-6 md:p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#FF9B8C]/30 group-hover:transform group-hover:-translate-y-2">
                  {/* Number Badge - LINKS statt rechts */}
                  <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-[#FF1B8D] to-[#FF9B8C] rounded-full flex items-center justify-center text-white font-bold shadow-lg">
                    {step.number}
                  </div>

                  {/* Content - Linksbündig auf Mobile */}
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 text-left">{step.title}</h3>
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed text-left">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
